import { gql } from '@apollo/client';

export const COMPETITORS_ANALYSIS = gql`
  query getCompetitorsAnalysis(
    $first: Int!
    $after: String
    $modelNames: [String!]
    $brandNames: [String!]
    $powerSupplies: [String!]
    $gearTypes: [String!]
    $tractionTypes: [String!]
    $vendorType: String
    $regions: [String!]
    $provinces: [String!]
    $isListingActive: Boolean
    $isPriceTiedToLoan: Boolean
    $isVehicleCoveredByWarranty: Boolean
    $interiorColors: [String!]
    $coatingColors: [String!]
    $priceLabels: [PriceLabel!]
    $vehicleRegistrationDateISO8601: StringRangeInput
    $engineDisplacementInCM3: NumberRangeInput
    $powerInHP: NumberRangeInput
    $priceInEUR: NumberRangeInput
    $vehicleKM: NumberRangeInput
    $orderBy: OrderByInput
    $modelVersions: [String!]
    $vendorNames: [String!]!
    $optionals: [String!]
    $websites: [Website!]
    $vehicleTypes: [VehicleType!]
    $isPictureAvailable: Boolean
    $isVATDeductible: Boolean
    $country: Country
  ) {
    getCompetitorsAnalysis(
      input: {
        first: $first
        after: $after
        optionals: $optionals
        modelNames: $modelNames
        brandNames: $brandNames
        powerSupplies: $powerSupplies
        gearTypes: $gearTypes
        tractionTypes: $tractionTypes
        vendorType: $vendorType
        regions: $regions
        provinces: $provinces
        isListingActive: $isListingActive
        isPriceTiedToLoan: $isPriceTiedToLoan
        isVehicleCoveredByWarranty: $isVehicleCoveredByWarranty
        interiorColors: $interiorColors
        coatingColors: $coatingColors
        priceLabels: $priceLabels
        vehicleRegistrationDateISO8601: $vehicleRegistrationDateISO8601
        engineDisplacementInCM3: $engineDisplacementInCM3
        powerInHP: $powerInHP
        priceInEUR: $priceInEUR
        vehicleKM: $vehicleKM
        orderBy: $orderBy
        vendorNames: $vendorNames
        modelVersions: $modelVersions
        websites: $websites
        vehicleTypes: $vehicleTypes
        isPictureAvailable: $isPictureAvailable
        isVATDeductible: $isVATDeductible
        country: $country
      }
    ) {
      pageInfo {
        endCursor
        hasNextPage
        __typename
      }
      listings {
        id
        brandName
        modelName
        modelVersion
        vehicleKM
        vehicleType
        vendorType
        vendorName
        publishDateISO8601
        saleDateISO8601
        vehicleRegistrationDateISO8601
        cityName
        provinceName
        regionName
        website
        url
        isVehicleCoveredByWarranty
        isPictureAvailable
        isVATDeductible
        priceInformation {
          currency
          current
          isPriceTiedToLoan
          indicators {
            marketAverage
            priceLabel
            referenceArea
            marketMaximum
            marketMinimum
            __typename
          }
          __typename
        }
        __typename
      }
      amountOfListingsMatchingCriteria
      uniqueVehicleCodesAmount
      __typename
    }
  }
`;
